import {
  AnalyticsItemCategory,
  AnalyticsItemVariant,
} from "../analytics.types";
import { gaPushEvent } from "../base.analytics";
import { AnalyticsItemReturnData } from "../common.analytics";

// TODO: Check what to do with legacy using "organisation"
enum Event {
  COMPANY_SHARE = "organisation_share",
  COMPANY_REDIRECT = "organisation_redirect",
}

type CompanyItemPayload = {
  company: { id: string; name: string };
  listName: string;
};

function convertCompanyToItemData(
  payload: CompanyItemPayload
): AnalyticsItemReturnData {
  const { company, listName } = payload;
  return {
    item_id: company.id,
    item_name: company.name,
    item_brand: company.name, // NOTE: Companies are a brand themselves.
    item_category: "organisation", // TODO: Check what to do with legacy using "organisation"
    item_category2: AnalyticsItemCategory.STANDARD,
    item_variant: AnalyticsItemVariant.ORGANISATION, // TODO: Check what to do with legacy using "organisation"
    item_list_name: listName,
  };
}

export function gaEventCompanyShare(payload: CompanyItemPayload) {
  gaPushEvent(Event.COMPANY_SHARE, {
    ecommerce: {
      items: [convertCompanyToItemData(payload)],
    },
  });
}

export function gaEventCompanyRedirect(payload: CompanyItemPayload) {
  gaPushEvent(Event.COMPANY_REDIRECT, {
    ecommerce: {
      items: [convertCompanyToItemData(payload)],
    },
  });
}
